export default __webpack_public_path__ + "images/II.4948e00.png";